import styled from 'styled-components'

import { breakpoints } from '@/config/layout'

const ImageBackgroundContainer = styled.div<{ gridColumns: string }>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 0fr;
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;

  @media ${breakpoints.s} {
    grid-template-columns: ${({ gridColumns }) => gridColumns};
  }
`

const ImageBackgroundFill = styled.div<{ backgroundColor: string }>`
  background-color: ${({ theme }) => theme.Colors.Background.White};

  @media ${breakpoints.s} {
    background-color: ${({ backgroundColor }) => backgroundColor};
  }
`

const ImageBackgroundImage = styled.img<{ imagePosition?: string }>`
  object-fit: cover;
  object-position: ${({ imagePosition }) => imagePosition ?? 'center'};
  height: 100%;
  width: 100%;
`

export { ImageBackgroundContainer, ImageBackgroundFill, ImageBackgroundImage }
